/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function BtnMenu({
    label, options, 
    onSelection, 
    transparent = false, 
    menuWidth = 'w-full', 
    position = 'bottom', 
    title = '', 
    customClassName,
    domPosition = 'absolute',
    displayOption = option => option.label}){
    const labelCss = "border border-gray-300 text-sm inline-flex font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-100 justify-center rounded-md bg-white";
    return (
        <Menu
            as="div"
            className={`relative inline-block text-left ${
                transparent && "h-full w-full"
            }`}
        >
            <div className={transparent && "h-full w-full"}>
                <Menu.Button title={title}
                className={customClassName ? customClassName :`${!transparent && labelCss} ${
                    transparent && "h-full"
                } w-full px-4 py-2 truncate`}
                >
                {label || ""}
                {!transparent && (
                    <ChevronDownIcon
                    className="-mr-1 ml-2 h-5 w-5"
                    aria-hidden="true"
                    />
                )}
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className={`${position == 'up' && 'bottom-full'} ${domPosition} md:right-0 z-10 mt-2 ${menuWidth} origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}>
                <div className="py-1">
                    {options?.map((option) => {
                    return (
                        <Menu.Item key={option.slug}>
                        {({ active }) => (
                            <a
                            className={classNames(
                                active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                                option?.slug == "delete" &&
                                "text-red-700 ",
                                "block px-2 py-1 text-sm cursor-pointer"
                            )}
                            onClick={() => onSelection(option)}
                            >
                            {displayOption(option)}
                            </a>
                        )}
                        </Menu.Item>
                    );
                    })}
                </div>
                </Menu.Items>
            </Transition>
        </Menu>
    );
}
